var _a, _b, _c, _d;
import { __decorate, __metadata } from "tslib";
import { Component } from 'decorators';
import { StudioService } from 'modules/application/detail/portal-submodule-builder/templates/builder/studio/services/StudioService';
import SparkleGradientIcon from 'assets/img/icons/sparkle-ai-gradient.svg';
import View from './StudioTrial.view.html';
import './StudioTrial.styles.scss';
import StudioTrialModal from 'modules/application/detail/portal-submodule-builder/templates/builder/studio/components/StudioTrialModal';
import { BlipToastService } from 'modules/shared/BlipToastService';
import angular from 'angular';
import { PlanStatus } from 'modules/application/detail/portal-submodule-builder/templates/builder/studio/types/plan';
let StudioTrialController = class StudioTrialController {
    static $inject = ['StudioService', 'ModalService', 'BlipToastService', '$translate'];
    constructor(StudioService, ModalService, BlipToastService, $translate) {
        'ngInject';
        this.StudioService = StudioService;
        this.ModalService = ModalService;
        this.BlipToastService = BlipToastService;
        this.$translate = $translate;
        //#region Properties
        this.sparkleGradientIcon = SparkleGradientIcon;
        this.isTrialActive = false;
        this.shouldShowTrial = false;
        this.remainingTrialDays = 0;
        this.isUpdatePlanModalOpen = false;
        //#region Methods
        this.startTrial = () => {
            this.ModalService.showModal(StudioTrialModal({
                confirm: () => this.confirmTrial(),
            }));
        };
        this.confirmTrial = async () => {
            try {
                this.BlipToastService.show('success', {
                    msg: this.$translate.instant('studioTrial.start.toasts.success'),
                });
                await this.StudioService.applyTrialToTenant({ origin: 'navBar' });
            }
            catch (error) {
                this.BlipToastService.show('danger', {
                    msg: this.$translate.instant('studioTrial.start.toasts.error'),
                });
            }
        };
        this.onUpgradePlanClick = () => {
            this.isUpdatePlanModalOpen = true;
        };
        this.closeModal = () => {
            this.isUpdatePlanModalOpen = false;
        };
        this.refreshTrialStatus = async () => {
            const status = await this.StudioService.shouldShowTrialRegisterOption();
            this.shouldShowTrial = status === PlanStatus.AVAILABLE_TO_TRIAL;
            if (this.shouldShowTrial) {
                return;
            }
            const plan = await this.StudioService.getPlanStatusByTenant();
            if (plan.isTrial && status === PlanStatus.AVAILABLE_TO_UPGRADE) {
                this.isTrialActive = true;
                this.remainingTrialDays = plan?.daysToNextBlock || 0;
            }
        };
        this.unsubscribe = this.StudioService.onStatusChange(() => {
            this.refreshTrialStatus();
        });
    }
    $onInit() {
        this.refreshTrialStatus();
    }
    $onDestroy() {
        this.unsubscribe();
    }
};
//#endregion
StudioTrialController.$inject = ['StudioService', 'ModalService', 'BlipToastService', '$translate'];
StudioTrialController = __decorate([
    Component({
        controllerAs: '$ctrl',
        template: View,
    }),
    __metadata("design:paramtypes", [typeof (_a = typeof StudioService !== "undefined" && StudioService) === "function" ? _a : Object, Object, typeof (_b = typeof BlipToastService !== "undefined" && BlipToastService) === "function" ? _b : Object, typeof (_d = typeof angular !== "undefined" && (_c = angular.translate) !== void 0 && _c.ITranslateService) === "function" ? _d : Object])
], StudioTrialController);
export { StudioTrialController };
